import axios from 'axios';

// Base API configuration
const API_BASE_URL = 'https://be.jodi.ac/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Information API functions
export const getInformationBySlug = async (slug) => {
  try {
    const response = await api.get(`/information/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching information:', error);
    throw error;
  }
};

export default api;
